import ky from 'ky'
import { API_URL } from '@/utils/constants'
import type {
  PublicInvoiceResponse,
  PreparePaymentRequest,
  PreparePaymentResponse,
  SubmitPaymentRequest,
  SubmitPaymentResponse,
} from '@/types/invoice'

const api = ky.create({
  prefixUrl: API_URL,
  timeout: 30000,
})

/**
 * Fetch public invoice by payment token
 */
export async function getPublicInvoice(
  paymentToken: string
): Promise<PublicInvoiceResponse> {
  return api.get(`pay/${paymentToken}`).json()
}

/**
 * Mark invoice as viewed
 */
export async function markInvoiceViewed(paymentToken: string): Promise<void> {
  await api.post(`pay/${paymentToken}/viewed`)
}

/**
 * Prepare payment transaction
 */
export async function preparePayment(
  paymentToken: string,
  data: PreparePaymentRequest
): Promise<PreparePaymentResponse> {
  return api
    .post(`pay/${paymentToken}/prepare-payment`, { json: data })
    .json()
}

/**
 * Submit signed payment transaction
 */
export async function submitPayment(
  paymentToken: string,
  data: SubmitPaymentRequest
): Promise<SubmitPaymentResponse> {
  return api
    .post(`pay/${paymentToken}/submit-payment`, { json: data })
    .json()
}

/**
 * Get PDF download URL
 */
export function getPdfUrl(paymentToken: string): string {
  return `${API_URL}/pay/${paymentToken}/pdf`
}
